import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "dropdown", "option", "empty"]
  static values = { selected: String, selectedLabel: String }

  open() {
    this.dropdownTarget.classList.remove("hidden")
    this.inputTarget.select()
  }

  close() {
    this.dropdownTarget.classList.add("hidden")
    this.inputTarget.value = this.selectedLabelValue
    this.filter("")
  }

  toggle() {
    if (this.dropdownTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  search() {
    this.filter(this.inputTarget.value)
    this.dropdownTarget.classList.remove("hidden")
  }

  select(event) {
    const option = event.currentTarget
    this.selectedValue = option.dataset.value
    this.selectedLabelValue = option.dataset.label
    this.hiddenTarget.value = this.selectedValue
    this.inputTarget.value = this.selectedLabelValue
    this.filter("")
    this.dropdownTarget.classList.add("hidden")
  }

  clear(event) {
    event.stopPropagation()
    this.selectedValue = ""
    this.selectedLabelValue = ""
    this.hiddenTarget.value = ""
    this.inputTarget.value = ""
    this.filter("")
  }

  filter(query) {
    const q = query.toLowerCase()
    let visibleCount = 0

    this.optionTargets.forEach(option => {
      const label = option.dataset.label.toLowerCase()
      const visible = label.includes(q)
      option.classList.toggle("hidden", !visible)
      if (visible) visibleCount++
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleCount > 0)
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  connect() {
    this.filter("")
    this._clickOutside = this.clickOutside.bind(this)
    document.addEventListener("click", this._clickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this._clickOutside)
  }
}
